import { theme } from 'lib/theme';
import { View, ViewProps } from 'react-native';

const size = theme.padding * 2;

export const Gap = ({
  children,
  style,
}: {
  children: React.ReactNode;
  style?: ViewProps['style'];
}) => {
  return (
    <View
      style={[
        {
          gap: size,
        },
        style,
      ]}
    >
      {children}
    </View>
  );
};
